import z from "zod";

import { LeadOrigin, LeadStatus } from "@/modules/common/types/Leads.enum";

export const leadSchema = z.object({
  name: z.string().trim().min(1, "É necessário informar o nome!"),
  company: z.string().trim().min(1, "É necessário informar a empresa!"),
  email: z.string().trim().min(1, "É necessário informar o e-mail!").pipe(z.email("O e-mail deve ser válido")),
  phoneNumber: z.string().trim().optional(),
  segment: z.string().optional(),
  originType: z.enum(LeadOrigin, "É necessário selecionar a origem!"),
  interest: z.string().trim().optional(),
});

export type LeadFormData = z.infer<typeof leadSchema>;

export const leadEditSchema = leadSchema.extend({
  status: z.enum(LeadStatus, "É necessário selecionar o status!"),
  responsibleById: z.string().nullable().optional(),
  observation: z.string().trim().optional(),
});

export type LeadEditFormData = z.infer<typeof leadEditSchema>;
